import { useNavigate } from "react-router";
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported
import fluidsImage from '../assets/fluids.jpg';
import printerImage from '../assets/Printer.jpg';
import sparepartsImage from '../assets/Spareparts.jpg';
import machineImage from '../assets/Machine.jpg';

const category = [
    {
        image: fluidsImage,
        name: 'Fluids'
    },
    {
        image: printerImage,
        name: 'Printer'
    },
    {
        image: sparepartsImage,
        name: 'Spareparts'
    },
    {
        image: machineImage,
        name: 'Machine'
    },
    
];

const Category = () => {
    const navigate = useNavigate();

    return (
        <section className="bg-light py-5">
            <div className="container">
                <div className="row mb-4 text-center">
                    <div className="col-md-12">
                        <h3 className="main-heading">Our Categories</h3>
                        <div className="underline mx-auto my-3"></div>
                    </div>
                </div>
                <div className="row">
                    {category.map((item, index) => (
                        <div key={index} className="col-md-3 mb-4">
                            <div
                                onClick={() => navigate(`/category/${item.name.toLowerCase()}`)}
                                className="card border-0 shadow-sm cursor-pointer"
                                style={{
                                   
                                   
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                   
                                }}
                            >
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="card-img-top p-3"
                                    style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'contain' }}
                                />
                                <div className="card-body text-center">
                                    <h5 className='card-title'>{item.name}</h5>
                                </div>
                                <button
                                                className="btn btn-primary w-40 mt-auto mx-5 mb-3"
                                                onClick={() => navigate(`/category/${item.name.toLowerCase()}`)}
                                                type="button"
                                            >
                                                View Products
                                            </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Category;
